import React from "react";
import RowMenu from "../../util/RowMenu";
import Modal from "../../util/Modal";
import PostLink from "../../util/PostLink";
import EditLearningOutcomeModal from "./EditLearningOutcomeModal";
import PropTypes from "prop-types";

import { IntlProvider } from "react-intl";
import { translations, locale } from "../../util/i18n";

const AdminScenarioLearningOutcomeRowManual = (props) => {
  const options = [
    {
      title: "admin-area.scenarios.dropdown.edit-learning-outcome",
      component: Modal,
      params: {
        title: "admin-area.scenarios.dropdown.edit-learning-outcome",
        content: EditLearningOutcomeModal({ url: props.updateUrl, details: { ...props.details } }),
      },
    },
    {
      title: "admin-area.scenarios.dropdown.delete-learning-outcome",
      component: PostLink,
      params: {
        method: "delete",
        url: props.deleteUrl,
        confirmMessage: "admin-area.scenarios.dropdown.delete-learning-outcome.confirm-message",
        refresh: true,
      },
    },
  ];

  return (
    <IntlProvider locale={locale} key={locale} messages={translations[locale]}>
      <RowMenu options={options}></RowMenu>
    </IntlProvider>
  );
};

AdminScenarioLearningOutcomeRowManual.propTypes = {
  updateUrl: PropTypes.string.isRequired,
  deleteUrl: PropTypes.string,
  details: PropTypes.object,
};

export default AdminScenarioLearningOutcomeRowManual;
